export const PAYMENT_STATUSES = {
  created: 'created',
  pending: 'pending',
  success: 'success',
  error: 'error',
};

export const PAYMENT_FILTERS = [
  { id: 'all', name: 'Все' },
  { id: PAYMENT_STATUSES.created, name: 'Создан' },
  { id: PAYMENT_STATUSES.pending, name: 'В процессе' },
  { id: PAYMENT_STATUSES.success, name: 'Успешно' },
  { id: PAYMENT_STATUSES.error, name: 'Ошибка' },
];

export const PAYMENT_WIDTHS = [8, 20, 15, 15, 12, 15, 10, 5]; // margin right

export const PAYMENT_HEADER_COLUMNS = [
  { text: '№', width: PAYMENT_WIDTHS[0] },
  { text: 'Действие', width: PAYMENT_WIDTHS[1] },
  { text: 'Сумма', width: PAYMENT_WIDTHS[2] },
  { text: 'Тип оплаты', width: PAYMENT_WIDTHS[3] },
  { text: 'Пользователь', width: PAYMENT_WIDTHS[4] },
  { text: 'Дата создания', width: PAYMENT_WIDTHS[5] },
  { text: 'Статус', width: PAYMENT_WIDTHS[6] },
  { text: '', width: PAYMENT_WIDTHS[7] },
];

export const getActionText = (action) => {
  switch (action) {
    case 'donation':
      return 'Донат';
    case 'personal_service':
      return 'Персональная услуга';
    case 'organization_promotion':
      return 'Продвижение предложения';
    default:
      return action;
  }
};

export const getPaymentTypeText = (type) => {
  switch (type) {
    case 'google_pay':
      return 'Google Pay';
    case 'apple_pay':
      return 'Apple Pay';
    case 'rf_card':
      return 'РФ карта';
    case 'world_card':
      return 'Международная карта';
    default:
      return type;
  }
};

export const getStatusText = (status) => {
  switch (status) {
    case PAYMENT_STATUSES.created:
      return 'Создан';
    case PAYMENT_STATUSES.pending:
      return 'В процессе';
    case PAYMENT_STATUSES.success:
      return 'Успешно';
    case PAYMENT_STATUSES.error:
      return 'Ошибка';
    default:
      return status;
  }
};
